export default __webpack_public_path__ + "static/heroimg_mobile-4ed9fa9c3fab256818e688c0e9438e4e.png";